import { Star } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "~/components/ui/tooltip";
import { cn } from "~/lib/utils";

interface FavoriteButtonProps {
  favorite: boolean;
  onToggle: () => void;
  className?: string;
}

/** Favorite toggle for a card or list row. Suppresses the click so it works
 *  inside a clickable parent (a `<Link>` or an onClick row); the icon fills
 *  when favorited. */
export const FavoriteButton = ({ favorite, onToggle, className }: FavoriteButtonProps) => {
  const label = favorite ? "Unfavorite" : "Favorite";
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          aria-label={label}
          aria-pressed={favorite}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onToggle();
          }}
          className={cn(
            "inline-flex size-7 cursor-pointer items-center justify-center rounded-md text-muted-foreground",
            "transition-colors hover:bg-muted hover:text-foreground",
            "focus-visible:outline-none focus-visible:ring-ring/50 focus-visible:ring-[3px]",
            favorite && "text-amber-400 hover:text-amber-400",
            className
          )}
        >
          <Star className={cn("size-4", favorite && "fill-current")} aria-hidden="true" />
        </button>
      </TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  );
};
